import React, { memo, useCallback, useContext, useMemo, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import FileExplorerContext from '../../../contexts/FileExplorerContext';
import { editElement } from '../../../api/actions/Documents';
import { toast } from 'react-toastify';

const EditElementModal = ({ show, onClose, element }) => {
    const { onOpenFolder, fullPath } = useContext(FileExplorerContext);

    const [name, setName] = useState(
        element.isDirectory ? element.name : element.file.fileName
    );
    const [isLoading, setIsLoading] = useState(false);

    const disableSubmit = useMemo(() => {
        if (name.length === 0) {
            return true;
        }

        if (!element.isDirectory && name === element.file.fileName) {
            return true;
        }

        if (element.name === name) {
            return true;
        }

        return false;
    }, [element, name]);

    const elementType = useMemo(() => {
        if (element.isDirectory) {
            return 'Folder';
        }

        return 'File';
    }, [element]);

    const onEdit = useCallback(
        async (event) => {
            event.preventDefault();
            if (isLoading || name.length === 0) {
                return;
            }

            setIsLoading(true);

            try {
                const currentFolder =
                    fullPath.length === 0
                        ? ''
                        : fullPath[fullPath.length - 1].id;

                await editElement(element.id, name);
                onOpenFolder(currentFolder);
                onClose();
            } catch (error) {
                console.error(error);
                toast.error(
                    `Something went wrong while renaming the ${
                        element.isDirectory ? 'folder' : 'file'
                    }. Please try again.`,
                    {
                        className: 'custom-toast',
                    }
                );
            } finally {
                setIsLoading(false);
            }
        },
        [fullPath, name, onOpenFolder, isLoading, onClose, element]
    );

    const onNameChange = useCallback((event) => {
        const { value } = event.target;

        setName(value);
    }, []);

    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header closeButton>Edit {elementType}</Modal.Header>
            <Modal.Body>
                <Form onSubmit={onEdit}>
                    <Form.Text>{elementType} name</Form.Text>
                    <Form.Control
                        name="name"
                        required
                        value={name}
                        onChange={onNameChange}
                        placeholder={`${elementType} name`}
                    />
                    <div className="d-flex justify-content-end mt-4">
                        <Button type="submit" disabled={disableSubmit}>
                            {isLoading ? <Spinner size="sm" /> : 'Save'}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default memo(EditElementModal);
